/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Per_MonthInputs */

const en_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ mo`)
};

const de_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ Monat`)
};

const fr_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ mois`)
};

const es_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ mes`)
};

const it_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ mese`)
};

const nl_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ ma`)
};

const pl_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ mies.`)
};

const fi_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ kuukausi`)
};

const da_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ md`)
};

const sv_pricing_per_month = /** @type {(inputs: Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ mån`)
};

/**
* | output |
* | --- |
* | "/ mo" |
*
* @param {Pricing_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_per_month = /** @type {((inputs?: Pricing_Per_MonthInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Per_MonthInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_per_month(inputs)
	if (locale === "fr") return fr_pricing_per_month(inputs)
	if (locale === "es") return es_pricing_per_month(inputs)
	if (locale === "it") return it_pricing_per_month(inputs)
	if (locale === "nl") return nl_pricing_per_month(inputs)
	if (locale === "pl") return pl_pricing_per_month(inputs)
	if (locale === "fi") return fi_pricing_per_month(inputs)
	if (locale === "da") return da_pricing_per_month(inputs)
	if (locale === "sv") return sv_pricing_per_month(inputs)
	return en_pricing_per_month(inputs)
});